import { render, staticRenderFns } from "./ConfiguracaoBalanca.vue?vue&type=template&id=75662c7a&scoped=true"
import script from "./ConfiguracaoBalanca.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoBalanca.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracaoBalanca.vue?vue&type=style&index=0&id=75662c7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75662c7a",
  null
  
)

export default component.exports